<template>
  <!-- <v-system-bar color="primary" dark class="toolbar elevation-2"> -->
  <v-app-bar
    color="transparent"
    flat
  >
    <v-spacer />

    <v-btn
      text
      class="capital--btn btn--plain mr-6"
    >
      Home
    </v-btn>
    <v-btn
      text
      class="capital--btn btn--plain mr-12"
    >
      Help
    </v-btn>
  </v-app-bar>
</template>

<script>
// const PATH_TO_PROTECTED_ROUTE = '/'
export default {
  name: 'ToolbarLoggedOut',
  // props: {
  //   authenticated: Boolean,
  // },
  methods: {
  }
}

</script>

<style>
</style>